import React, {Component} from "react"
import {_getTeamDetails} from "../../../../services/apis/AdminServices";
import timeHuman from "../../../../helpers/time/timeHuman";
import TeamMaster from "./TeamMaster";
import TeamMember from "./TeamMember";
import {Alert} from "reactstrap";

class TeamPage extends Component {
    state = {
        team: {},
        error: ''
    }

    componentDidMount() {
        this._fetchTeamDetails()
    }

    _fetchTeamDetails = () => {
        const {match} = this.props
        const {teamId} = match.params

        _getTeamDetails(teamId)
            .then(result => {
                const {success, data, message} = result

                if (success) {
                    this.setState({team: data})
                } else {
                    this.setState({error: message})
                }
            })
    }

    render() {
        const {team, error} = this.state
        const {owner, members} = team

        return (
            <div>
                {!!error ? <Alert color="danger">{error}</Alert> :
                    <div id="TeamDetailsPage">
                        <div className="From form-inline">
                            <table className="table border-0">
                                <tbody>
                                {
                                    !!owner &&
                                    <tr className="owner">
                                        <td>Owner</td>
                                        <td><TeamMaster owner={owner}/></td>
                                    </tr>
                                }
                                <tr className="members">
                                    <td>Members</td>
                                    <td>
                                        <table>
                                            <tbody>
                                            {!!members && members.map(member => {
                                                return <TeamMember key={member._id} member={member}/>
                                            })}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr className="membership">
                                    <td>Membership</td>
                                    <td>
                                        {!!owner &&
                                        <div>
                                            <div>
                                                Plan: {owner.membership.plan.title}
                                            </div>

                                            <div>
                                                Start: {timeHuman(owner.membership.start, 'DD/MM/YYYY')}
                                            </div>

                                            <div>
                                                Finish: {timeHuman(owner.membership.finish, 'DD/MM/YYYY')}
                                            </div>
                                        </div>
                                        }
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default TeamPage


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/team/TeamPage.js